const initTabs = () => {
    const tabs = [...document.querySelectorAll(".tabs")];

    if (tabs.length > 0) {
        tabs.forEach((tab) => {
            const tabContent = [...tab.querySelectorAll(".tabs__content")];
            const tabLinks = [...tab.querySelectorAll(".tabs__link")];

            const openTab = (tabIndex = 0) => {
                tabContent.forEach((element, i) => {
                    const isActive = i === tabIndex;
                    element.classList.toggle("active", isActive);
                });

                tabLinks.forEach((element, i) => {
                    element.classList.toggle("active", i === tabIndex);
                });
            }

            openTab(0)

            tabLinks.forEach((link, i) => {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    openTab(i);
                });
            });
        });
    }
}

// select functions
const selectInit = () => {
    const selectArray = document.querySelectorAll('.custom-select');

    if (selectArray.length > 0) {
        selectArray.forEach((element, index) => {
            const selectTag = element.querySelector('select'),
                selectOption = selectTag.querySelectorAll('option');

            const selectWrapper = document.createElement('div'),
                selectLabel = document.createElement('div'),
                selectItemList = document.createElement('div'),
                selectLabelSpan = document.createElement('span');

            selectWrapper.classList.add('select__wrapper');

            selectLabel.classList.add('select__label');
            selectLabelSpan.classList.add('select__name');

            selectLabelSpan.textContent = selectTag[selectTag.selectedIndex].textContent;
            selectLabel.append(selectLabelSpan);

            selectItemList.classList.add('select__content', 'select__content--hidden')

            selectWrapper.append(selectLabel);
            element.append(selectWrapper);

            selectOption.forEach((element, index) => {
                const selectItem = document.createElement('div');
                const selectSpan = document.createElement('span');
                selectItem.classList.add('select__item');
                selectSpan.textContent = element.textContent

                selectItem.append(selectSpan);
                // Check if the delegated event is triggered properly
                selectItem.addEventListener('click', (e) => {
                    const selectItemTag = e.target.closest('.select').querySelector('select'),
                        selectItemOptions = selectItemTag.querySelectorAll('option');

                    selectItemOptions.forEach((element, index) => {
                        if (element.textContent === selectItem.textContent) {
                            selectItemTag.selectedIndex = index;
                            selectLabelSpan.textContent = element.textContent;

                            // Trigger change event when selectIndex is changed
                            const event = new Event('change', { bubbles: true });
                            selectItemTag.dispatchEvent(event);
                        }
                    });

                    selectLabel.click();
                });

                selectItemList.append(selectItem);
            });

            selectWrapper.append(selectItemList);

            // Check if the click event is properly handled
            selectLabel.addEventListener('click', (e) => {
                e.stopPropagation();

                closeAllSelect(selectLabel);
                window.innerHeight - selectItemList.getBoundingClientRect().bottom < 100 ? (selectItemList.classList.add('select__content--top'), selectLabel.classList.add('select__label--top')) : (selectItemList.classList.remove('select__content--top'), selectLabel.classList.remove('select__label--top'))

                selectItemList.classList.toggle('select__content--hidden');
                selectLabel.classList.toggle('select__label--active');
                element.classList.toggle('select--active');
            });

            selectTag.addEventListener('change', () => {
                const selectItemOptions = selectTag.options,
                    selectedItem = selectItemOptions[selectTag.selectedIndex];

                selectLabelSpan.textContent = selectedItem.textContent;
            })
        });

        document.addEventListener('click', closeAllSelect);
    }
}

const closeAllSelect = (select) => {
    const selectContentArray = document.querySelectorAll('.select__content'),
        selectLabelArray = document.querySelectorAll('.select__label');

    selectLabelArray.forEach((element, index) => {
        element !== select ? (element.classList.remove('select__label--active'), selectContentArray[index].classList.add('select__content--hidden')) : null;
    });
}


document.addEventListener('DOMContentLoaded', () => {
    selectInit();
    initTabs();

    const blockArray = document.querySelectorAll('.block');

    if (blockArray.length) {
        blockArray.forEach(element => {
            const elementWrapper = element.querySelector('.block__wrapper');
            elementWrapper.addEventListener('scroll', () => {
                const isScrolledHorizontally = elementWrapper.scrollWidth - elementWrapper.clientWidth <= elementWrapper.scrollLeft;

                const isScrolledVertically = elementWrapper.scrollHeight - elementWrapper.clientHeight <= elementWrapper.scrollTop;
                if (isScrolledHorizontally && isScrolledVertically) {
                    element.classList.add('block--scrolled');
                } else {
                    element.classList.remove('block--scrolled');
                }
            });

        })
    }


    // Get the calendar element
    let date = new Date(); // creates a new date object with the current date and time
    let year = date.getFullYear(); // gets the current year
    let month = date.getMonth(); // gets the current month (index based, 0-11)

    const day = document.querySelector(".calendar-content"); // selects the element with class "calendar-dates"
    const currdate = document.querySelector("#currentMonth"); // selects the element with class "calendar-current-date"
    const prenexIcons = [document.querySelector("#nextMonth"), document.querySelector("#prevMonth")]; // selects all elements with class "calendar-navigation span"

    const months = [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь"
    ]; // array of month names

    const days = [
        "ВС",
        "ПН",
        "ВТ",
        "СР",
        "ЧТ",
        "ПТ",
        "СБ",
    ]; // array of month names

    // function to generate the calendar
    const manipulate = () => {
        let dayone = new Date(year, month, 1).getDay();
        let lastdate = new Date(year, month + 1, 0).getDate();
        let dayend = new Date(year, month, lastdate).getDay();
        let monthlastdate = new Date(year, month, 0).getDate();
        const getPrevMonth = month - 1 < 0 ? months[11] : months[month - 1];
        const getNextMonth = month + 1 > 11 ? months[0] : months[month + 1];
        let lit = "";
        for (let i = dayone; i > 0; i--) {
            lit += `
            <label class="calendar-day calendar-day--inactive">
            <input type="checkbox" class="calendar-day__input">
            <div class="calendar-day__wrapper">
                <div class="calendar-day__header">
                ${monthlastdate - i + 1}<br> <span>${getPrevMonth}</span>
                </div>
                <svg class="calendar-day__icon">
                    <use xlink:href="img/sprites/sprite.svg#check" />
                </svg>
                <div class="calendar-day__footer">
                    Четверг
                </div>
            </div>
        </label>
            `;
        }

        for (let i = 1; i <= lastdate; i++) {
            let isInactive = i === 4 ? 'disabled' : null;
            let isToday = i === date.getDate() && month === new Date().getMonth() && year === new Date().getFullYear() ? "active" : "";
            lit += `
                <label class="calendar-day ${isToday}">
                    <input type="checkbox" ${isInactive} class="calendar-day__input">
                    <div class="calendar-day__wrapper">
                        <div class="calendar-day__header">
                            ${i} <br> <span>${months[month]}</span>
                        </div>
                        <svg class="calendar-day__icon">
                            <use xlink:href="img/sprites/sprite.svg#check" />
                        </svg>
                        <div class="calendar-day__footer">
                            Четверг
                        </div>
                    </div>
                </label>
            `;
        }

        for (let i = dayend; i < 6; i++) {
            lit += `
                <label class="calendar-day calendar-day--inactive">
                    <input type="checkbox" class="calendar-day__input">
                    <div class="calendar-day__wrapper">
                        <div class="calendar-day__header">
                            ${i - dayend + 1}<br> <span>${months[month + 1]}</span>
                        </div>
                        <svg class="calendar-day__icon">
                            <use xlink:href="img/sprites/sprite.svg#check" />
                        </svg>
                        <div class="calendar-day__footer">
                            Четверг
                        </div>
                    </div>
                </label>
            `

        }
        currdate.innerText = `${months[month]} «${year}»`;
        prenexIcons[1].querySelector('p').innerHTML = `${getPrevMonth} «${year}»`;
        prenexIcons[0].querySelector('p').innerHTML = `${getNextMonth} «${year}»`;
        day.innerHTML = lit;
        const allCurrentDays = day.querySelectorAll('.calendar-day');
        allCurrentDays.forEach((element,index)=>{
            const daysofWeek = element.querySelector('.calendar-day__footer');
            daysofWeek.innerHTML = days[index % 7];
        });
    }

    manipulate();

    prenexIcons.forEach(icon => {
        icon.addEventListener("click", () => {
            month = icon.id === "prevMonth" ? month - 1 : month + 1;
            if (month < 0 || month > 11) {
                date = new Date(year, month, new Date().getDate());
                year = date.getFullYear();
                month = date.getMonth();
            }
            else {
                date = new Date();
            }
            manipulate();
        });
    });

    const formArray = document.querySelectorAll('.form');

    if (formArray.length) {
        formArray.forEach(form => {
            const formInputArray = document.querySelectorAll('.form-input');
            if (!formInputArray.length) return

            formInputArray.forEach(formInput => {
                const input = formInput.querySelector('input');

                input.addEventListener('input', () => {
                    formInput.classList.remove('form-input--error');
                })

                input.addEventListener('change', () => {
                    if (!input.checkValidity()) formInput.classList.add('form-input--error');
                });
            });
        })
    }


    const burger = document.querySelector('.burger');
    const aside = document.querySelector('.content__aside');

    if (burger && aside) {
        burger.addEventListener('click', (e) => {
            e.preventDefault();

            burger.classList.toggle('burger--active');
            aside.classList.toggle('content__aside--active');
        });
    }

    const notification = document.querySelector('.notification');


    if (notification) {
        const notificationLink = notification.querySelector('.notification-link');

        notificationLink.addEventListener('click', (e) => {
            e.preventDefault();

            notification.classList.toggle('notification--active');
        });

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.notification')) {
                notification.classList.remove('notification--active');
            }
        })
    }

});